



















import TextBox from '@/views/atoms/TextBox.vue'
import DatePicker from '@/views/atoms/DatePicker.vue'

export default
  components: {
    TextBox
    DatePicker
  }

  props:
    name:
      type: String
      default: null
    group:
      type: String
      default: null
    rightFit:
      type: Boolean
      default: false
    defValue:
      type: String
      default: ""
    isPartner:
      type: Boolean
      default: false
    index:
      type: Number
      default: null
  watch: {
    defValue: (v) ->
      @calendar_value = v
      @value = v
  }

  data: ()->
    show_calendar: false
    calendar_value: ''
    value: ''

  created: () ->
    @value = @defValue

  methods: {
    showCalendar: (e) ->
      @show_calendar = true
      @$emit('click')
    closeCalendar: (e) ->
      @show_calendar = false
    handleDateChange: (date)->
      @calendar_value = date
      @value = date
      param =
        name: 'pick_up_date'
        val: date
        index: @index
      @$emit('change', param)
  }
